import { Controller } from "@hotwired/stimulus";
import * as CoreUI from "@coreui/coreui-pro";

const STORAGE_KEY = "coreui-sidebar-narrow";

export default class extends Controller {
  connect() {
    if (localStorage.getItem(STORAGE_KEY) === "true") {
      this.element.classList.add("sidebar-narrow");
    }

    this.sidebar = CoreUI.Sidebar.getOrCreateInstance(this.element);
  }

  storeNarrowState() {
    requestAnimationFrame(() => {
      const isNarrow = this.element.classList.contains("sidebar-narrow");
      localStorage.setItem(STORAGE_KEY, String(isNarrow));
    });
  }
}
